<template>
  <div class="person-page">
    <!-- round：图片显示为圆形 -->
    <van-image
      class="person-avatar"
      width="100"
      height="100"
      round
      fit="fit"
      :src="userdetailList.avatar ? userdetailList.avatar : headAvatar"
    />
    <div class="deit-avatar">
      <span>修改头像请使用电脑版</span>
      <span class="deit-avatar-website">www.lujia.loopon.cn</span>
    </div>
    <van-form class="person-form" @submit="onSubmit" ref="personForm">
      <div class="custom-form-item">
        <div class="label-container">
          <span class="custom-lable">昵称</span>
        </div>
        <van-field
          :rules="rules.nickName"
          :error-message="errMsg.nickName"
          v-model="personForm.nickName"
          name="nickName"
        />
      </div>
      <div class="custom-form-item gender-wrapper">
        <div class="label-container">
          <span class="custom-lable">性别</span>
        </div>
        <van-radio-group v-model="personForm.gender" direction="horizontal" class="person-gender">
          <van-radio name="男">男</van-radio>
          <van-radio name="女">女</van-radio>
          <van-radio name="保密">保密</van-radio>
        </van-radio-group>
      </div>
      <div class="custom-form-item">
        <div class="label-container">
          <span class="custom-lable">职业</span>
        </div>
        <van-field
          readonly
          clickable
          :value="personForm.occupationName"
          placeholder="选择职业"
          @click="showOccupationPicker = true"
        />
      </div>
      <div class="custom-form-item">
        <div class="label-container">
          <span class="custom-lable">常驻城市</span>
        </div>
        <van-field
          readonly
          clickable
          :value="personForm.permanentCityName"
          placeholder="选择常驻城市"
          @click="showCityPicker = true"
          name="permanentCityName"
        />
      </div>
      <div class="custom-form-item">
        <div class="label-container">
          <span class="custom-lable">出生日期</span>
        </div>
        <van-field
          readonly
          clickable
          :value="processBirthday(personForm.birthday)"
          placeholder="选择出生日期"
          @click="showBirthdayPicker = true"
          name="birthday"
        />
      </div>
      <div class="custom-form-item">
        <div class="label-container">
          <span class="custom-lable">绑定手机</span>
        </div>
        <van-field style="display: none" v-model="personForm.phone" name="phone" />
        <van-field class="disabled-van-field" disabled v-model="phone" name="phone" />
      </div>
      <div class="custom-form-item">
        <div class="label-container">
          <span class="custom-lable">收货地址</span>
        </div>
        <van-field v-model="personForm.address" name="address" />
      </div>
      <van-button class="person-form-save" type="primary" native-type="submit">保存</van-button>
    </van-form>
    <van-popup v-model="showBirthdayPicker" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="onConfirmDate"
        @cancel="onCancleDate"
        @change="onChangeDate"
        type="date"
        title="选择年月日"
      />
    </van-popup>
    <van-popup v-model="showCityPicker" round position="bottom">
      <van-area
        title="常驻城市"
        :value="personForm.permanentCity"
        :area-list="provinceObj"
        @confirm="onConfirmCity"
        @cancel="onCancleCity"
        @change="onChangeCity"
      />
    </van-popup>
    <van-popup v-model="showOccupationPicker" round position="bottom">
      <van-picker
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
        @cancel="cancleOccupation"
        @confirm="onConfirmOccupation"
        :columns="occupationColumns"
        @change="onOccupationChange"
      />
    </van-popup>
  </div>
</template>
<script>
import {
  Form,
  Image as VanImage,
  Button,
  Field,
  RadioGroup,
  Radio,
  Picker,
  Popup,
  Area,
  DatetimePicker
} from "vant";
import { dateFormat } from "@/utils/MobileGlobal";
import { mapState, mapActions } from "vuex";
import { ckeckNickNameUsed } from "@/axios/service/user.js";
import { userModify } from "@/axios/service/travel.js";
import headAvatar from "@/assets/images/avatar.png";
import { mobileMsgSuc } from "@/utils/MobileGlobal";
export default {
  name: "person-page",
  components: {
    [Area.name]: Area,
    [Field.name]: Field,
    [Form.name]: Form,
    [Button.name]: Button,
    VanImage,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker
  },
  data() {
    let validateNickName = (value, rule) => {
      if (value === "") {
        this.errMsg.nickName = "";
        return true;
      } else {
        // 所有特殊字符的正则表达式
        let patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im;
        if (patrn.test(value)) {
          this.errMsg.nickName = "特殊字符不可用，请重新输入";
          return false;
        } else {
          if (value === this.oldNickName) {
            this.errMsg.nickName = "";
            return true;
          }
          ckeckNickNameUsed({
            oemId: this.apolloConfig.WORK.oemId,
            nickName: value
          }).then(json => {
            if (json.respCode === 100) {
              if (json.data.isNickNameExist) {
                //如果被注册了
                this.errMsg.nickName = "很遗憾，昵称已被占用";
                return false;
              } else {
                this.errMsg.nickName = "";
                return true;
              }
            } else {
              this.errMsg.nickName = "";
              return true;
            }
          });
        }
      }
    };
    return {
      headAvatar: headAvatar,
      rules: {
        nickName: [
          { required: false, message: "请输入昵称" },
          { validator: validateNickName, message: "请输入昵称" }
        ]
      },
      errMsg: {
        nickName: ""
      },
      phone: "",
      currentDate: new Date(),
      maxDate: new Date(),
      minDate: null,
      showBirthdayPicker: false,
      showCityPicker: false,
      showOccupationPicker: false,
      personForm: {
        avatar: "",
        nickName: "",
        gender: "",
        occupation: "",
        occupationName: "",
        permanentCity: "",
        permanentCityName: "",
        birthday: "",
        phone: "",
        address: "",
        userId: this.$cookie.get("userInfo_userId")
      },
      occupationColumns: [
        "程序员",
        "产品销售",
        "客户服务",
        "新媒体运营",
        "公务员",
        "法务顾问",
        "教师",
        "演员",
        "导游/旅行达人",
        "咨询/顾问",
        "高级主管",
        "平面设计",
        "编辑",
        "艺术家",
        "摄影师",
        "自由职业",
        "其他"
      ]
    };
  },
  watch: {
    "personForm.phone"(newVal) {
      this.phone = newVal.substr(0, 4) + "****" + newVal.substr(8);
    },
    userdetailList(value) {
      this.personForm.address = value.address ? value.address : "";
      this.personForm.avatar = value.avatar ? value.avatar : "";
      this.personForm.birthday = value.birthday ? value.birthday : "";
      this.personForm.gender = value.gender ? value.gender : "";
      this.personForm.nickName = value.nickName
        ? value.nickName
        : `用户${this.$cookie.get("userInfo_userId")}`;
      this.oldNickName = this.personForm.nickName;
      this.personForm.occupation = value.occupation ? value.occupation : "";
      //根据occupation设置occupationName
      this.personForm.occupationName = this.occupationColumns[
        this.personForm.occupation - 1
      ];
      this.personForm.phone = value.phone ? value.phone : "";
      this.personForm.permanentCity = value.permanentCity
        ? value.permanentCity
        : "";
      //根据用户所在城市code计算用户所在城市名
      if (this.provinceObj !== {} && value.permanentCity) {
        let countryCode = value.permanentCity.toString();
        let cityCode = `${countryCode.substr(0, 4)}00`;
        let provinceCode = `${countryCode.substr(0, 2)}0000`;
        let countryName = this.provinceObj.county_list[countryCode];
        let cityName = this.provinceObj.city_list[cityCode];
        let provinceName = this.provinceObj.province_list[provinceCode];
        this.personForm.permanentCityName = `${provinceName}/${cityName}/${countryName}`;
      }
    }
  },
  created() {
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    this.minDate = new Date(currentYear - 70, 1, 1);
    this.getCityListCode({ userId: this.$cookie.get("userInfo_userId") });
  },
  computed: {
    ...mapState("PersonalStore", ["provinceObj", "userdetailList"])
  },
  methods: {
    processBirthday(birthday) {
      if (birthday) {
        return birthday.slice(0, 10);
      } else {
        return "";
      }
    },
    ...mapActions("PersonalStore", ["getCityListCode","getUserdetail"]),
    onConfirmOccupation(value, index) {
      this.personForm.occupation = index + 1;
      this.personForm.occupationName = value;
      this.showOccupationPicker = false;
    },
    cancleOccupation(value, index) {
      this.showOccupationPicker = false;
    },
    onSubmit() {
      this.$refs.personForm.validate("nickName").then(
        () => {
          let params = Object.assign({}, this.personForm);
          if (!params.birthday) {
            delete params.birthday;
          }
          userModify(params).then(json => {
            if (json.respCode === 100) {
              mobileMsgSuc("保存成功");
              this.getUserdetail(params);
            } else if (json.respCode === -100) {
              //保存失败
            } else if (json.respCode === -102) {
              //保存失败
            } else if (json.respCode === -500) {
              //保存失败
            } else if (json.respCode === -117) {
              //保存失败 用户名重复
            }
          });
        },
        () => {
        }
      );
    },
    onOccupationChange(picker, value, index) {
    },
    onConfirmCity(selectedCity) {
      /**
        0: {code: "320000", name: "江苏省"}
        1: {code: "320100", name: "南京市"}
        2: {code: "320105", name: "建邺区"}
       */
      this.personForm.permanentCity = selectedCity[2].code;
      this.personForm.permanentCityName = `${selectedCity[0].name}/${selectedCity[1].name}/${selectedCity[2].name}`;
      this.showCityPicker = false;
    },
    onCancleCity() {
      this.showCityPicker = false;
    },
    onChangeCity(picker, value, index) {
    },
    onConfirmDate(value) {
      let realDate = dateFormat("YYYY-mm-dd", value);
      this.personForm.birthday = realDate;
      this.showBirthdayPicker = false;
    },
    onCancleDate(value) {
      this.showBirthdayPicker = false;
    },
    onChangeDate(datePicker) {
    }
  }
};
</script>
<style lang="less">
.person-page {
  padding-top: 17px;
  padding-left: 35px;
  padding-right: 35px;
  @baseFontSize: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .person-avatar {
    width: 79px;
    height: 79px;
  }
  .deit-avatar {
    padding: 10px 0;
    width: 200px;
    margin-top: 14px;
    color: #999999;
    font-size:  13px;
  }
  .person-form {
    width: 100%;
    .van-field {
      border: 1px solid #ccc;
      border-radius: 5px;
      .van-field__control {
        font-size: 15px;
        color: #999999;
      }
    }
    .custom-form-item {
      margin-top: 5px;
      margin-bottom: 25px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .label-container {
        margin-right: 10px;
        text-align: left;
        // min-width: 30%;
        font-size: 15px;
        color: #333333;
        margin-bottom: 12px;
        // font-size: @baseFontSize;
        .custom-lable:after {
          content: ":";
        }
      }
    }
    .gender-wrapper {
      display: flex;
      flex-direction: row;
      .label-container {
        margin-bottom: 0px;
      }
      .person-gender {
        justify-content: space-between;
        .van-radio__icon--checked {
          .van-icon {
            background-color: #57dec1;
            border-color: #57dec1;
          }
        }
      }
      .van-radio-group {
        flex: 1;
        padding-left: 32px;
        font-size: 15px;
        // font-size: @baseFontSize;
      }
    }
    .disabled-van-field {
      background-color: #f5f7fa;
    }
    .person-form-save {
      width: 100%;
      border-radius: 3px;
      margin-bottom: 25px ;
    }
  }
}
</style>
